import PermissionChecker from '@/security/permission-checker';
import Permissions from '@/security/permissions';

export class NotificationsPermissions {
    constructor(currentUser) {
        const permissionChecker = new PermissionChecker(
            currentUser,
        );

        this.read = permissionChecker.match(
            Permissions.values.notificationsTemplateRead,
        );
        this.edit = permissionChecker.match(
            Permissions.values.notificationsTemplateEdit,
        );
    }
}
